const pascalCaseToSpaceSeparated = (input: string | null): string => {
  if (!input) return ''

  return input
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
}

export default pascalCaseToSpaceSeparated
